import { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const TreinamentosRoute = props => {
  const { isTreinamento } = useContext(UserContext);

  if (isTreinamento) {
    return <Route {...props} />;
  } else if (!isTreinamento) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default TreinamentosRoute;
